<template>
  <div>
    <v-dialog width="600" v-model="showModal">
      <v-card>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-6">
          <div class="white--text run-step__title">{{title}}</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="showModal = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <v-card-text class="pb-0">
          <div>
            <span>{{question}}</span>
          </div>
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-spacer />
          <apio-button
            button-size="medium"
            button-type="secondary"
            class="mr-2"
            @click="showModal = false"
          >
            Cancel
          </apio-button>
          <apio-button button-size="medium" @click="promptCallback()">
            Delete
          </apio-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'PromptModal',
  computed: {
    showModal: {
      set(v) {
        this.$emit("update:show", v);
      },
      get() { return this.show },
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Question',
    },
    question: {
      type: String,
      default: 'Are you sure?',
    },
  },
  mounted() {
    this.showModal = this.show
  },
  methods: {
    promptCallback() {
      this.$emit('callback')
      this.showModal = false
    },
  },
}
</script>
